/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  Flex,
  Heading,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";

interface OptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  titleIcon?:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | undefined;
  subTitle?: string;
  onSelection: (selection: string) => void;
  options?: {
    title: string;
    subTitle?: string;
    icon?: any;
    value: string;
  }[];
  isRequired?: boolean;
  isCentered?: boolean;
}

function OptionModal({
  isOpen,
  onClose,
  title,
  titleIcon,
  subTitle,
  onSelection,
  options,
  isRequired = false,
  isCentered = true,
}: OptionModalProps) {
  const modalContentRef = React.useRef<HTMLDivElement>(null);

  return (
    <Modal
      blockScrollOnMount
      isCentered={isCentered}
      closeOnEsc={!isRequired}
      closeOnOverlayClick={!isRequired}
      isOpen={isOpen}
      onClose={onClose}
      {...(isRequired
        ? {
            onOverlayClick: () => {
              if (modalContentRef.current) {
                modalContentRef.current.focus();
              }
            },
          }
        : {})}
    >
      <ModalOverlay />
      <ModalContent background="primary.500">
        <ModalBody p="1.25rem">
          <Flex gap="1rem">
            <Box>
              {titleIcon && (
                <IconButton
                  rounded="full"
                  size="lg"
                  aria-readonly
                  fontSize="1.5rem"
                  colorScheme="whiteAlpha"
                  aria-label="title_icon"
                  icon={<>{titleIcon}</>}
                />
              )}
            </Box>
            <Box color="whiteAlpha.900">
              <Heading as="h3" size="lg">
                {title}
              </Heading>
              <Text as="h5" size="md">
                {subTitle}
              </Text>
            </Box>
          </Flex>
          <Flex flexDirection="column" gap="0.5rem" mt="1.25rem">
            {options?.map((option, index) => (
              <Flex
                key={`option-${index}`}
                alignItems="center"
                background="whiteAlpha.700"
                py="1rem"
                px="1rem"
                borderRadius="5px"
                cursor="pointer"
                transition="all 0.2s ease-in-out"
                _hover={{
                  background: "primary.600",
                  color: "whiteAlpha.900",
                }}
                gap="1rem"
                onClick={() => onSelection(option.value)}
              >
                <Box>
                  {option.icon && <Icon as={option.icon} fontSize="2rem" />}
                </Box>
                <Box>
                  <Heading as="h6" size="md">
                    {option.title}
                  </Heading>
                  {option.subTitle && <Text size="xs">{option.subTitle}</Text>}
                </Box>
              </Flex>
            ))}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default OptionModal;
